export default __webpack_public_path__ + "13bf0688afb4f0b325c639ac4fe4dcf4.jpg";